<template>
  <div>
    <el-dialog
      title="派送试算"
      :visible="visible"
      width="750px"
      :close-on-click-modal="false"
      @close="handleClose">
      <div>
        <el-form :model="form" ref="form" :rules="rules" label-width="80px" size="normal">
          <div>
            <p class="form-span-title">收货信息</p>
            <el-row :gutter="20">
              <el-col :span="12" :offset="0">
                <el-form-item label="国家">
                  <el-input v-model="form.countryName" disabled></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12" :offset="0">
                <el-form-item label="邮编" prop="code">
                  <el-input v-model="form.code"></el-input>
                </el-form-item>
              </el-col>
              <!-- <el-col :span="12" :offset="0">
                <el-form-item label="州" prop="province">
                  <el-select v-model="form.province" no-data-text="暂无匹配数据，请检查输入信息是否有误或联系客服人员" clearable filterable remote reserve-keyword :loading="pLoading" :remote-method="(query) => { remoteMethod(query, 1) }" @change="provinceChange" style="width: 100%">
                      <el-option v-for="item in provinceOptions"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                      </el-option>
                    </el-select>
                </el-form-item>
              </el-col> -->
            </el-row>
            
            <!-- <el-row :gutter="20">
              <el-col :span="12" :offset="0">
                 <el-form-item label="城市" prop="city">
        <el-select v-model="form.city" no-data-text="暂无匹配数据，请检查输入信息是否有误或联系客服人员" clearable filterable remote reserve-keyword :loading="cLoading" :remote-method="(query) => { remoteMethod(query, 2) }" style="width:100%">
                      <el-option v-for="item in cityOptions"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                      </el-option>
                      </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12" :offset="0">
                <el-form-item label="邮编" prop="code">
                  <el-input v-model="form.code"></el-input>
                </el-form-item>
              </el-col>
            </el-row> -->
            <el-form-item label="详细地址" prop="address">
              <el-input style="width: calc(100% - 120px);" type="textarea" resize="none" rows="1" v-model="form.address"></el-input>
              <el-button style="width: 100px; margin-left: 15px" type="primary" size="default" @click="trail">点击试算</el-button>
            </el-form-item>
          </div>
          <!-- <div>
            <p class="form-span-title">货量信息</p>
            <el-row :gutter="20">
              <el-col :span="8" :offset="0">
                <el-form-item label="重量(KG)" prop="weight" label-width="100px">
                  <el-input v-model="form.weight"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8" :offset="0">
                <el-form-item label="体积(CBM)" prop="cbm" label-width="100px">
                  <el-input v-model="form.cbm"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8" :offset="0">
                <el-button type="primary" size="default" @click="trail">试算</el-button>
                <el-button type="primary" size="default" @click="checkCityDeliveryData">查看所有城市派送距离</el-button>
              </el-col>
            </el-row>
            
          </div> -->
        </el-form>

        <!-- <div>
          <p class="form-span-title">派送价格表</p>
          <el-table :data="priceTableData" border stripe max-height="260">
            <el-table-column v-for="(col, index) in priceColumns"
              :prop="col.prop"
              :key="index"
              :label="col.title" align="center">
              <template slot-scope="scope">{{scope.row[col.prop]}} {{col.contact && scope.row[col.contact] ? `${scope.row[col.contact]}/${col.billingUnit}` : ''}}</template>
            </el-table-column>
          </el-table>
        </div> -->
        
        <div style="margin-top: 40px">
          <!-- <p class="form-span-title" style="margin-bottom: 5px">派送预估费用</p> -->
          <p class="form-span-title" style="margin-bottom: 10px">试算结果</p>
          <!-- <el-table :data="coastTableData" border stripe>
            <el-table-column v-for="(item, index) in coastColumns"
              :prop="item.name"
              :key="index"
              :label="item.label" align="center">
              <template slot-scope="scope">
                <div v-if="item.name === 'companyType'">私人地址</div>
                <div v-if="item.code">
                  {{item.code[scope.row[item.name]] || ''}}
                </div>
                <div v-else>
                  {{scope.row[item.name] || ''}}
                </div>
              </template>
            </el-table-column>
          </el-table> -->
          <div style="line-height: 28px; display: flex; justify-content: space-between">
            <p style="width: 50%">
              <label>派送距离：</label>
              <span class="trail-info">{{coastData.distance || coastData.distance === 0 ? `${coastData.distance} KM` : ''}}</span>
            </p>
            <p style="width: 50%">
              <label>拆柜仓库：</label>
              <span class="trail-info">{{coastData.polWarehouseAddress || ''}}</span>
            </p>
            <!-- <p>
              <label>目的地邮编：</label>
              <span class="trail-info">{{coastData.code || ''}}</span>
            </p> -->
            <!-- <p>
              <label>
                计费重
                <el-tooltip :content="coastData.chargeWeightCalProcess" placement="top" effect="dark" v-if="coastData.chargeUnit && `${coastData.chargeWeight} ${coastData.chargeUnit}` !== coastData.chargeWeightCalProcess">
                  <div slot="content" style="line-height: 18px">
                    <template v-if="coastData.chargeUnit && (coastData.chargeUnit === 'PLTS' || coastData.chargeUnit === 'PK')">
                      <p>{{coastData.chargeUnit === 'PK' ? '卡车' : '卡板'}}可拼容重：{{coastData.unitWeight}}KG</p>
                      <p>{{coastData.chargeUnit === 'PK' ? '卡车' : '卡板'}}可拼容积：{{coastData.unitCbm}}CBM</p>
                    </template>
                    <p v-for="(process, i) in coastData.processList" :key="i">{{process}}</p>
                  </div>
                  <img class="icon" :src="ossPath + '/pages/home/icon_tiops.png'" />
                </el-tooltip>
                ：
              </label>
              <span class="trail-info">{{coastData.chargeWeight}} {{coastData.chargeUnit}}</span>
            </p> -->
            <!-- <p>
              <label>
                预估派送费用
                <el-tooltip :content="coastData.amountCalProcess" placement="top" effect="dark" v-if="coastData.amount">
                  <img class="icon" :src="ossPath + '/pages/home/icon_tiops.png'" />
                </el-tooltip>
                ：
              </label>
              <span class="trail-info">{{coastData.amount ? `${coastData.amount} ${coastData.currency}` : ''}}</span>
            </p> -->
          </div>
        </div>
      </div>
      <div slot="footer" align="center">
        <!-- <el-button style="width: 100px" type="primary" size="default" @click="trail">试 算</el-button> -->
        <!-- <el-button @click="handleClose">关闭</el-button> -->
      </div>
    </el-dialog>
    <!-- <el-dialog
      title="所有城市派送距离"
      :visible.sync="distanceVisible"
      width="800px"
      @close="distanceVisible = false">
      <div>
        <div style="margin-bottom: 10px">
          <span></span>
          <el-select v-model="queryProvince" clearable filterable @change="queryProvinceChange" style="width: 300px">
            <el-option v-for="item in distanceProvinceOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
          <el-select v-model="queryCity" clearable filterable style="width: 300px">
            <el-option v-for="item in distanceCityOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
          
          <el-button type="primary" size="default" @click="handleSearch">查询</el-button>
          
        </div>
        <el-table :data="distanceTableData" border stripe>
          <el-table-column v-for="(col, index) in distanceColumns"
            :prop="col.name"
            :key="index"
            :label="col.label" align="center">
          </el-table-column>
        </el-table>
        <el-pagination
          style="margin-top: 10px"
          align="right"
          @size-change="sizeChange"
          @current-change="currentChange"
          :current-page.sync="current"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalNum" background>
          :pager-count="7">
        </el-pagination>
        
      </div>
      <span slot="footer" >
      </span>
    </el-dialog> -->
    
  </div>
</template>

<script>
// import { filterData } from '@common/setCoastTableData'
export default {
  props: {
    visible: {
      default: false
    },
    groupInfo: {
      default: () => {
        return {}
      }
    }
  },
  data() {
    var validateCode = (rule, value, callback) => {
      var reg = /(^[1-9]\d*(\.\d{1,3})?$)|(^0(\.\d{1,3})?$)/;
      if (value.length > 15 || value.length < 1) {
        callback(new Error("只能为1-15个字符"));
      }
      if (value <= 0) {
        callback(new Error("只能大于零且保留三位小数"));
      }
      var re = /^[0-9]+.?[0-9]*/; //判断字符串是否为数字//判断正整数/[1−9]+[0−9]∗]∗/
      if (!re.test(value)) {
        callback(new Error("请输入数字"));
      }
      if (!reg.test(value)) {
        callback(new Error("只能大于零且保留三位小数"));
      } else {
        callback();
      }
    };
    var validateCode2 = (rule, value, callback) => {
      var reg = /(^[1-9]\d*(\.\d{1,2})?$)|(^0(\.\d{1,2})?$)/;
      if (value.length > 15 || value.length < 1) {
        callback(new Error("只能为1-15个字符"));
      }
      if (value <= 0) {
        callback(new Error("只能大于零且保留两位小数"));
      }
      var re = /^[0-9]+.?[0-9]*/; //判断字符串是否为数字//判断正整数/[1−9]+[0−9]∗]∗/
      if (!re.test(value)) {
        callback(new Error("请输入数字"));
      }
      if (!reg.test(value)) {
        callback(new Error("只能大于零且保留两位小数"));
      } else {
        callback();
      }
    };
    return {
      form: {},
      rules: {
        // province: [{ required: true, message: '不能为空' }],
        // city: [{ required: true, message: '不能为空' }],
        code: [{ required: true, message: '不能为空' }],
        weight: [{ required: true, message: '不能为空' }, { required: true, validator: validateCode2 }],
        cbm: [{ required: true, message: '不能为空' }, { required: true, validator: validateCode }],
      },
      provinceOptions: [],
      cityOptions: [],
      pLoading: false,
      cLoading: false,
      priceTableData: [],
      priceColumns: [],
      coastTableData: [],
      coastData: {},
      coastColumns: [
        {
          label: '目的地',
          name: 'city'
        },
        {
          label: '派送方式',
          name: 'deliveryType',
          code: {
            KP: '卡派',
            HP: '海派',
            WC: '整柜直送'
          }
        },
        {
          label: '业务类型',
          name: 'companyType'
        },
        {
          label: '预估费用',
          name: 'amount'
        },
        {
          label: '邮编',
          name: 'zipCode'
        },
        {
          label: '币种',
          name: 'currency'
        }
      ],
      distanceVisible: false,
      queryCity: null,
      queryProvince: null,
      distanceProvinceOptions: [],
      distanceCityOptions: [],
      queryPLoading: false,
      queryCLoading: false,
      distanceTableData: [],
      distanceColumns: [
        // {
        //   label: '国家',
        //   name: 'countryName'
        // },
        {
          label: '州',
          name: 'state'
        },
        {
          label: '城市',
          name: 'city'
        },
        {
          label: '邮编',
          name: 'zipCode'
        },
        {
          label: '派送距离（KM）',
          name: 'distance'
        }
      ],
      current: 1,
      pageSize: 10,
      totalNum: 0
    }
  },
  watch: {
    visible(val) {
      if (val) {
        // this.$nextTick(() => {
        //   this.queryRemoteMethod(1)
        //   this.queryRemoteMethod(2)
        //   this.$refs.form.clearValidate()
        // })
        this.form = {
          // countryId: this.groupInfo.countryId,
          countryName: this.groupInfo.toCountryName
        }
      } else {
        this.init()
      }
    }
  },
  created() {
    
  },
  methods: {
    init() {
      // this.provinceOptions = []
      // this.cityOptions = []
      // this.pLoading = false
      // this.cLoading = false
      // this.priceTableData = []
      // this.priceColumns = []
      // this.coastTableData = []
      this.coastData = {}
      // this.distanceVisible = false
      // this.queryCity = null
      // this.queryProvince = null
      // this.distanceProvinceOptions = []
      // this.distanceCityOptions = []
      // this.queryPLoading = false
      // this.queryCLoading = false
      // this.distanceTableData = []
      // this.current = 1
      // this.pageSize = 10
      // this.totalNum = 0
    },
    getGroupDeliveryPrice() {
      // // /api/distance/getFollowGroupDeliveryPrice
      // this.axios.get(`/api/distance/getFollowGroupDeliveryPrice?groupId=${this.groupInfo.id}`).then(res => {
      //   if (res.data.code == 200) {
      //     const data = {
      //       ...res.data.data,
      //       dispatchQuotePriceDetailList: res.data.data.quotedPriceDetailList
      //     }
      //     const {
      //       tableData,
      //       column
      //     } = filterData(data, true)
      //     this.priceTableData = tableData
      //     this.priceColumns = column
      //   }
      // })
    },
    handleClose() {
      this.$emit('close')
    },
    trail() {
      this.$refs.form.validate(valid => {
        if (!valid) return
        else {
          const data = {
            priceId: this.groupInfo.productPriceHeaderId,
            address: this.form.address,
            zipCode: this.form.code
          }
          this.axios.post(`/api/FBAfee/deliveryDistanceTrial`, data).then(res => {
            if (res.data.code == 200) {
              // this.coastTableData = [res.data.data]
              this.coastData = res.data.data
              // if (this.coastData.chargeWeightCalProcess.includes(';')) {
              //   this.coastData.processList = this.coastData.chargeWeightCalProcess.split(';')
              // } else {
              //   this.coastData.processList = [this.coastData.chargeWeightCalProcess]
              // }
            } else {
              this.coastData = {}
              this.$message.error(res.data.message)
            }
          }).catch(err => {
            console.log(err)
            this.coastData = {}
            this.$message.error(err.message || "试算失败,请稍后重试")
          })
        }
      })
    },
    // provinceChange(val) {
    //   if (this.form.city) this.form.city = ''
    //   this.cityOptions = []
    // },
    // queryProvinceChange(val) {
    //   if (this.queryCity && val) this.queryCity = ''
    //   this.queryRemoteMethod(2)
    // },
    // checkCityDeliveryData() {
    //   this.distanceVisible = true
    //   this.handleSearch()
    // },
    // queryRemoteMethod(type) {
    //   console.log(this.form)
    //   const data = {
    //     countryId: this.form.countryId,
    //     type
    //   }
    //   let url = ''
    //   if (type === 1) {
    //     url = `/api/distance/getCityDistanceStateList?groupId=${this.groupInfo.id}`
    //   } else if (type === 2) {
    //     url = `/api/distance/getCityDistanceCityList?groupId=${this.groupInfo.id}`
    //     if (this.queryProvince) url = `/api/distance/getCityDistanceCityList?groupId=${this.groupInfo.id}&stateId`
    //   }
    //   this.axios.get(url).then(res => {
    //     console.log(res)
    //     if (res.data.datas) {
    //       this[type === 1 ? 'distanceProvinceOptions' : 'distanceCityOptions'] = res.data.datas.map(v => {
    //         return {
    //           value: v.id,
    //           // label: v.namec
    //           label: v.name
    //         }
    //       })
    //     } else {
    //       this[type === 1 ? 'distanceProvinceOptions' : 'distanceCityOptions'] = []
    //     }
    //   }).catch(() => {})
    // },
    // remoteMethod(query, type) {
    //   if(query) {
    //     console.log(this.form)
    //     const data = {
    //       countryId: this.form.countryId,
    //       type
    //     }
    //     if (type === 1) {
    //       data.stateName = query
    //       this.pLoading = false
    //     } else if (type === 2) {
    //       if (!this.form.province) return this.$message.warning('请先选择州')
    //       data.stateId = this.form.province
    //       data.cityName = query
    //       this.cLoading = false
    //     }
    //     this.axios.post('/api/filedata/findCountryInfoAll', data).then(res => {
    //       this.pLoading = false
    //       this.cLoading = false
    //       console.log(res)
    //       if (res.data.datas) {
    //         this[type === 1 ? 'provinceOptions' : 'cityOptions'] = res.data.datas.map(v => {
    //           return {
    //             value: v.id,
    //             // label: v.namec
    //             label: v.namee
    //           }
    //         })
    //       } else {
    //         this[type === 1 ? 'provinceOptions' : 'cityOptions'] = []
    //       }
    //     }).catch(() => {
    //       this.pLoading = false
    //       this.cLoading = false
    //     })
    //   } else {

    //   }
      
    // },
    getProvinceData() {},
    // handleQueryCityDistance() {
    //   // /api/distance/getCityDistanceByWarehouse
    //   const data = {
    //     groupId: this.groupInfo.id,
    //     stateId: this.queryProvince,
    //     cityId: this.queryCity,
    //     pageNum: this.current,
    //     pageSize: this.pageSize
    //   }
    //   this.axios.post('/api/distance/getCityDistanceByWarehouse', data).then(res => {
    //     console.log(res)
    //     if (res.data.code == 200) {
    //       this.distanceTableData = res.data.data.records
    //       this.totalNum = res.data.data.total
    //     }
    //   })
    // },
    handleSearch() {
      this.current = 1
      this.handleQueryCityDistance()
    },
    sizeChange(val) {
      this.pageSize = val
      this.current = 1
      this.handleQueryCityDistance()
    },
    currentChange(val) {
      this.current = val
      this.handleQueryCityDistance()
    }
  }
}
</script>

<style lang="scss" scoped>
  .form-span-title {
    margin-bottom: 14px;
    font-weight: 600;
    font-size: 17px;
  }
  .icon {
    width: 16px;
    height: 16px;
    border-radius: 50%;
    margin-left: 6px;
    vertical-align: -2px;
    cursor: pointer;
  }
  .trail-info {
    color: #FF4D01
  }
  /deep/ .el-dialog {
    border-radius: 10px;
  }
  /deep/ .el-textarea__inner {
    height: 40px
  }
  /deep/ .el-dialog__header {
    font-size: 24px;
    padding-left: 38px;
    padding-right: 38px
  }
   /deep/ .el-dialog__body {
    padding: 20px 38px 
  }
</style>


// WEBPACK FOOTER //
// src/components/placeOrder/components/deliveryTrail/index.vue